(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire00d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire00d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h0yJl", function(module, exports) {

$parcel$export(module.exports, "decodeQueryParams", function () { return $262bca86827acf22$export$6025d61c37f75253; });

var $kBZoE = parcelRequire("kBZoE");
var $262bca86827acf22$export$6025d61c37f75253 = function(query) {
    var entries = new URLSearchParams(query).entries();
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kBZoE._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (result[key]) {
                var currentValue = result[key];
                if (!Array.isArray(currentValue)) {
                    currentValue = [
                        currentValue
                    ];
                    result[key] = currentValue;
                }
                currentValue.push(value);
            } else result[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};

});
parcelRegister("kBZoE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f016e371a265690f$export$71511d61b312f219; });

var $fZCRS = parcelRequire("fZCRS");

var $knBcK = parcelRequire("knBcK");

var $49x4n = parcelRequire("49x4n");

var $1NsP6 = parcelRequire("1NsP6");
function $f016e371a265690f$export$71511d61b312f219(arr, i) {
    return (0, $fZCRS._)(arr) || (0, $knBcK._)(arr, i) || (0, $1NsP6._)(arr, i) || (0, $49x4n._)();
}

});
parcelRegister("fZCRS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba4ab3e04af5a1c8$export$71511d61b312f219; });
function $ba4ab3e04af5a1c8$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("knBcK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $03d42ca7edbcaa09$export$71511d61b312f219; });
function $03d42ca7edbcaa09$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("49x4n", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3061a79b31f47639$export$71511d61b312f219; });
function $3061a79b31f47639$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("1NsP6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $14f0b9b832db9609$export$71511d61b312f219; });

var $ifvsP = parcelRequire("ifvsP");
function $14f0b9b832db9609$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $ifvsP._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $ifvsP._)(o, minLen);
}

});
parcelRegister("ifvsP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d49208cc91539140$export$71511d61b312f219; });
function $d49208cc91539140$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});




parcelRegister("cr1U1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $90d97b7d5a45885f$export$71511d61b312f219; });
function $90d97b7d5a45885f$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


var $h0yJl = parcelRequire("h0yJl");
function $ae6d6fc22a088c75$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $3704bfa0c5d9913b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3704bfa0c5d9913b$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $3704bfa0c5d9913b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3704bfa0c5d9913b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $5bab7ebd24f60b12$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $8805f4be77169222$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5bab7ebd24f60b12$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $1110e77a396dfbda$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1110e77a396dfbda$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1110e77a396dfbda$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $33345473c24fad8c$export$89db4734f6c919c4 = function(metric) {
    {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "https://client-metrics.truv.com", true);
        xhr.setRequestHeader("Content-Type", "application/json");
        // eslint-disable-next-line no-console
        console.log("truv_metric", metric);
        var _metric_attributes;
        var body = JSON.stringify([
            {
                metrics: [
                    {
                        name: metric.name,
                        type: metric.type,
                        value: metric.value,
                        timestamp: Date.now(),
                        attributes: (0, $8805f4be77169222$export$71511d61b312f219)({
                            host: window.location.host,
                            env: "prod",
                            version: "v1.318.0"
                        }, (_metric_attributes = metric.attributes) !== null && _metric_attributes !== void 0 ? _metric_attributes : {})
                    }
                ]
            }
        ]);
        xhr.send(body);
    }
};



var $h0yJl = parcelRequire("h0yJl");


var $9976d56c67b51897$export$d0e2ae08fc9533f5;
(function(BridgeWidgetMessageType) {
    BridgeWidgetMessageType["Init"] = "init";
    BridgeWidgetMessageType["SetBridgeTokenResponse"] = "set_bridge_token_response";
    BridgeWidgetMessageType["SetCategorizedCompaniesResponse"] = "set_categorized_companies_response";
    BridgeWidgetMessageType["SetProvidersResponse"] = "set_providers_response";
    BridgeWidgetMessageType["GoBack"] = "go_back";
    BridgeWidgetMessageType["ExternalLoginSuccess"] = "external_login_success";
    BridgeWidgetMessageType["BridgeOAuthResult"] = "bridge_oauth_result";
    BridgeWidgetMessageType["CustomFormPreviewInit"] = "custom_form_preview_init";
    BridgeWidgetMessageType["CustomFormPreviewSubmitResponse"] = "custom_form_preview_submit_response";
    BridgeWidgetMessageType["CustomFormSubmit"] = "custom_form_submit";
})($9976d56c67b51897$export$d0e2ae08fc9533f5 || ($9976d56c67b51897$export$d0e2ae08fc9533f5 = {}));


var $363bde3f99059239$export$cb62ff1a452a903a;
(function(FlowMessage) {
    FlowMessage["Available"] = "flow/available";
    FlowMessage["TitleChange"] = "flow/title-change";
    FlowMessage["OpenExternalLink"] = "flow/open-external-link";
    FlowMessage["Onload"] = "flow/onload";
    FlowMessage["Event"] = "flow/event";
    FlowMessage["Close"] = "flow/close";
    FlowMessage["Success"] = "flow/success";
})($363bde3f99059239$export$cb62ff1a452a903a || ($363bde3f99059239$export$cb62ff1a452a903a = {}));


var $de02b661938e3b6b$export$de3c5c76757a9816 = "truv/order";
var $de02b661938e3b6b$export$6c64c0450660f009;
(function(TruvOrderEventType) {
    TruvOrderEventType["Order"] = "order";
    TruvOrderEventType["Bridge"] = "bridge";
})($de02b661938e3b6b$export$6c64c0450660f009 || ($de02b661938e3b6b$export$6c64c0450660f009 = {}));






var $f30ccb32775195ad$export$f707581cefd6fe4b = {};
var $f30ccb32775195ad$export$76d01a7b7e3be059;
(function(ExitGoto) {
    ExitGoto["ProviderHelp"] = "ProviderHelp";
    ExitGoto["FindPaystub"] = "FindPaystub";
    ExitGoto["FindW2"] = "FindW2";
    ExitGoto["FindInsurancePolicy"] = "FindInsurancePolicy";
})($f30ccb32775195ad$export$76d01a7b7e3be059 || ($f30ccb32775195ad$export$76d01a7b7e3be059 = {}));
var $f30ccb32775195ad$export$6492445e2a7c8d03;
(function(ExitGotoNextScreen) {
    ExitGotoNextScreen["ManualDDS"] = "ManualDDS";
    ExitGotoNextScreen["DataSourceDocsUpload"] = "DataSourceDocsUpload";
    ExitGotoNextScreen["DataSourceFinancialAccounts"] = "DataSourceFinancialAccounts";
    ExitGotoNextScreen["DataSourcePayroll"] = "DataSourcePayroll";
    ExitGotoNextScreen["DataSourceTax"] = "DataSourceTax";
})($f30ccb32775195ad$export$6492445e2a7c8d03 || ($f30ccb32775195ad$export$6492445e2a7c8d03 = {}));


var $13c7c3b2195a3dc2$export$693e1fbc8da770bb = "dialog";






var $1caedaec5be797f9$export$11b099a658b17995;
(function(ProductType) {
    ProductType["ADMIN"] = "admin";
    ProductType["DEPOSIT_SWITCH"] = "deposit_switch";
    ProductType["PLL"] = "pll";
    ProductType["EMPLOYMENT"] = "employment";
    ProductType["INCOME"] = "income";
    ProductType["INSURANCE"] = "insurance";
    ProductType["TRANSACTIONS"] = "transactions";
    ProductType["ASSETS"] = "assets";
})($1caedaec5be797f9$export$11b099a658b17995 || ($1caedaec5be797f9$export$11b099a658b17995 = {}));
var $1caedaec5be797f9$export$e19b665d680cabdf;
(function(KeyEnv) {
    KeyEnv["DEV"] = "dev";
    KeyEnv["PROD"] = "prod";
    KeyEnv["SANDBOX"] = "sandbox";
})($1caedaec5be797f9$export$e19b665d680cabdf || ($1caedaec5be797f9$export$e19b665d680cabdf = {}));
var $1caedaec5be797f9$export$3c9e61791e6901e3;
(function(MappingType) {
    MappingType["Truv"] = "truv";
    MappingType["Manual"] = "manual";
})($1caedaec5be797f9$export$3c9e61791e6901e3 || ($1caedaec5be797f9$export$3c9e61791e6901e3 = {}));
var $1caedaec5be797f9$export$d92bfdf69074cc68;
(function(DepositType) {
    DepositType["AMOUNT"] = "amount";
    DepositType["ENTIRE"] = "entire";
    DepositType["PERCENT"] = "percent";
})($1caedaec5be797f9$export$d92bfdf69074cc68 || ($1caedaec5be797f9$export$d92bfdf69074cc68 = {}));
var $1caedaec5be797f9$export$accd73d198d77d2f;
(function(DataSource) {
    DataSource["PAYROLL"] = "payroll";
    DataSource["DOCS"] = "docs";
    DataSource["FINANCIAL_ACCOUNTS"] = "financial_accounts";
    DataSource["INSURANCE"] = "insurance";
    DataSource["TAX"] = "tax";
    DataSource["SCORING_ATTRIBUTES"] = "scoring_attributes";
})($1caedaec5be797f9$export$accd73d198d77d2f || ($1caedaec5be797f9$export$accd73d198d77d2f = {}));
var $1caedaec5be797f9$export$a86d43d077f08d16;
(function(OutdatedDataSourceFlowFromServer) {
    OutdatedDataSourceFlowFromServer["FALLBACK"] = "fallback";
    OutdatedDataSourceFlowFromServer["WATERFALL"] = "waterfall";
    OutdatedDataSourceFlowFromServer["MANUAL_SELECTION"] = "manual_selection";
    OutdatedDataSourceFlowFromServer["SMART_ROUTING"] = "smart_routing";
})($1caedaec5be797f9$export$a86d43d077f08d16 || ($1caedaec5be797f9$export$a86d43d077f08d16 = {}));
var $1caedaec5be797f9$export$3236679354e51180;
(function(DataSourceFlow) {
    DataSourceFlow["SMART_ROUTING"] = "smart_routing";
    DataSourceFlow["FALLBACK"] = "fallback";
    DataSourceFlow["MANUAL_SELECTION"] = "manual_selection";
})($1caedaec5be797f9$export$3236679354e51180 || ($1caedaec5be797f9$export$3236679354e51180 = {}));
var $1caedaec5be797f9$export$119429b4f7d53d7d;
(function(DocsUploadType) {
    DocsUploadType["Paystub"] = "PAYSTUB";
    DocsUploadType["W2"] = "W2";
    DocsUploadType["F1099"] = "F1099";
    DocsUploadType["F1040"] = "F1040";
    DocsUploadType["InsuranceHome"] = "INSURANCE_HOME_POLICY";
    DocsUploadType["InsuranceAuto"] = "INSURANCE_AUTO_POLICY";
})($1caedaec5be797f9$export$119429b4f7d53d7d || ($1caedaec5be797f9$export$119429b4f7d53d7d = {}));









var $h0yJl = parcelRequire("h0yJl");
var $2e9681744f3b402f$var$paths = function() {
    var _document_location = document.location, hostname = _document_location.hostname, href = _document_location.href, search = _document_location.search;
    var queryParams = (0, $h0yJl.decodeQueryParams)(search);
    var truvTestFlowBasePath = queryParams.TRUV_TEST_FLOW_BASE_PATH;
    var truvTestCdnUrl = queryParams.TRUV_TEST_CDN_URL;
    var _ref;
    var flowBasePath = (_ref = truvTestFlowBasePath !== null && truvTestFlowBasePath !== void 0 ? truvTestFlowBasePath : "https://cdn.truv.com/flow/index.html") !== null && _ref !== void 0 ? _ref : "";
    var _ref1;
    var cdnUrl = (_ref1 = truvTestCdnUrl !== null && truvTestCdnUrl !== void 0 ? truvTestCdnUrl : "https://cdn.truv.com") !== null && _ref1 !== void 0 ? _ref1 : "";
    var mobilePageResult = href.match(/https?\:\/\/[^\/]+\/([^\/]+)\/mobile.html/);
    var mobileBranchName = mobilePageResult && mobilePageResult[1] ? "/".concat(mobilePageResult[1]) : "";
    if (mobileBranchName) return {
        classic: flowBasePath.replace(cdnUrl, "".concat(cdnUrl).concat(mobileBranchName)),
        new: null
    };
    // only on demo app domains
    if (/^demo(.*)\.truveng.com$/.test(hostname)) {
        var branchName = queryParams.branch ? "/".concat(queryParams.branch) : "";
        if (branchName) return {
            classic: flowBasePath.replace(cdnUrl, "".concat(cdnUrl).concat(branchName)),
            new: null
        };
    }
    var _httpscdntruvcomssrindex;
    return {
        classic: flowBasePath,
        new: truvTestFlowBasePath ? null : (_httpscdntruvcomssrindex = "https://cdn.truv.com/ssr/index") !== null && _httpscdntruvcomssrindex !== void 0 ? _httpscdntruvcomssrindex : null
    };
}();
var $2e9681744f3b402f$export$dfceade7048162e2 = new URL($2e9681744f3b402f$var$paths.classic, document.location.origin).href;
var $2e9681744f3b402f$export$b0ef60cad22b508e = $2e9681744f3b402f$var$paths.new ? new URL($2e9681744f3b402f$var$paths.new, document.location.origin).href : null;




function $155f817efd42d637$export$71511d61b312f219(o, p) {
    $155f817efd42d637$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $155f817efd42d637$export$71511d61b312f219(o, p);
}


function $b973482bb46f63c0$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $155f817efd42d637$export$71511d61b312f219)(subClass, superClass);
}


function $cd5fd9695b54238a$export$71511d61b312f219(o) {
    $cd5fd9695b54238a$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cd5fd9695b54238a$export$71511d61b312f219(o);
}


function $90bbe29226d071c9$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($90bbe29226d071c9$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $8128b1907c83ddbd$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $cr1U1 = parcelRequire("cr1U1");
function $6414794486df2bbd$export$71511d61b312f219(self, call) {
    if (call && ((0, $cr1U1._)(call) === "object" || typeof call === "function")) return call;
    return (0, $8128b1907c83ddbd$export$71511d61b312f219)(self);
}


function $7edbffc731202888$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $90bbe29226d071c9$export$71511d61b312f219)();
    return function _createSuperInternal() {
        var Super = (0, $cd5fd9695b54238a$export$71511d61b312f219)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $cd5fd9695b54238a$export$71511d61b312f219)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6414794486df2bbd$export$71511d61b312f219)(this, result);
    };
}


// https://stackoverflow.com/a/21742107/275473
function $c2e2b57d23484fd4$export$942a24f0838e8755() {
    // @ts-expect-error
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // source http://detectmobilebrowsers.com/
    var isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4));
    if (!isMobile) return null;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) return "Windows Phone";
    if (/android/i.test(userAgent)) return "Android";
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    // @ts-expect-error
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return "iOS";
    return "unknown";
}


var $5c1d3452864e33ad$var$ADDITIONAL_SCALE = 1.05;
var $5c1d3452864e33ad$export$8538ca20052b93ad = 32;
var $5c1d3452864e33ad$export$8cbf726acefc850b = 70;
var $5c1d3452864e33ad$export$e8b10a10af2fe9a7 = 576;
var $5c1d3452864e33ad$var$MIN_DESKTOP_WIDGET_WIDTH = 324;
var $5c1d3452864e33ad$export$33eac6063ddb0fe1 = 736;
var $5c1d3452864e33ad$var$MIN_EMULATOR_DESKTOP_WIDGET_FULL_HEIGHT = $5c1d3452864e33ad$export$e8b10a10af2fe9a7 + $5c1d3452864e33ad$export$8cbf726acefc850b + $5c1d3452864e33ad$export$8538ca20052b93ad;
var $5c1d3452864e33ad$export$b5000213bb4ec32f = function(isEmulator) {
    return (!isEmulator ? $5c1d3452864e33ad$export$e8b10a10af2fe9a7 : $5c1d3452864e33ad$var$MIN_EMULATOR_DESKTOP_WIDGET_FULL_HEIGHT) * $5c1d3452864e33ad$var$ADDITIONAL_SCALE;
};
var $5c1d3452864e33ad$export$e822326ea8388e5c = function(screenHeight, isEmulator) {
    var SUM_SECTIONS_HEIGHT = isEmulator ? $5c1d3452864e33ad$export$8538ca20052b93ad + $5c1d3452864e33ad$export$8cbf726acefc850b : 0;
    return Math.min($5c1d3452864e33ad$export$33eac6063ddb0fe1, Math.max($5c1d3452864e33ad$export$e8b10a10af2fe9a7, screenHeight / $5c1d3452864e33ad$var$ADDITIONAL_SCALE - SUM_SECTIONS_HEIGHT));
};
var $5c1d3452864e33ad$export$136acee104ecd4c2 = function(widgetHeight) {
    return widgetHeight / $5c1d3452864e33ad$export$e8b10a10af2fe9a7 * $5c1d3452864e33ad$var$MIN_DESKTOP_WIDGET_WIDTH;
};
var $5c1d3452864e33ad$export$44b3f05b0cb1821d = $5c1d3452864e33ad$export$136acee104ecd4c2($5c1d3452864e33ad$export$33eac6063ddb0fe1);
var $5c1d3452864e33ad$export$5b18f7c6fa2072f9 = 576;
var $5c1d3452864e33ad$export$16c830612d15c75d = 16;


var $276aee0d389a2674$export$bbcd0e6c1e676d75 = function(focusEl) {
    var onFocus = function() {
        focusEl.focus();
    };
    var htmlElement = document.createElement("div");
    htmlElement.tabIndex = 0;
    htmlElement.addEventListener("focus", onFocus);
    return {
        htmlElement: htmlElement,
        dispose: function() {
            return htmlElement.removeEventListener("focus", onFocus);
        }
    };
};


var $1b1fc24fbadd3540$var$getOrigin = function(url) {
    return new URL(url).origin;
};
var $1b1fc24fbadd3540$var$classForWidgetDialog = "truv-dialog-root-element";
var $1b1fc24fbadd3540$export$3e24ee5c984ce043 = /*#__PURE__*/ function() {
    "use strict";
    function OpenedFrame(params) {
        (0, $ae6d6fc22a088c75$export$71511d61b312f219)(this, OpenedFrame);
        this.onMessage = params.onMessage;
        this.onClose = params.onClose;
        this.openTimestamp = Date.now();
        this.iframeRef = document.createElement("iframe");
        this.iframeRef.style.left = "0";
        this.iframeRef.style.right = "0";
        this.iframeRef.style.top = "0";
        this.iframeRef.style.bottom = "0";
        this.iframeRef.style.border = "0";
        this.iframeRef.title = params.title;
        this.iframeRef.width = "100%";
        this.iframeRef.height = "100%";
        this.iframeRef.id = params.id;
        // We need camera to use face scan verification for doordash for example
        this.iframeRef.allow = "web-share;camera";
        this.iframeRef.src = params.iframeSrc;
        this.iframeOrigin = $1b1fc24fbadd3540$var$getOrigin(params.iframeSrc);
        window.addEventListener("message", this.onMessage);
    }
    (0, $3704bfa0c5d9913b$export$71511d61b312f219)(OpenedFrame, [
        {
            key: "postMessage",
            value: function postMessage(message) {
                var _this_iframeRef_contentWindow;
                (_this_iframeRef_contentWindow = this.iframeRef.contentWindow) === null || _this_iframeRef_contentWindow === void 0 ? void 0 : _this_iframeRef_contentWindow.postMessage(message, this.iframeOrigin);
            }
        },
        {
            key: "changeIframeSrc",
            value: function changeIframeSrc(src) {
                this.iframeOrigin = $1b1fc24fbadd3540$var$getOrigin(src);
                this.iframeRef.src = src;
            }
        },
        {
            key: "changeIframeTitle",
            value: function changeIframeTitle(title) {
                this.iframeRef.title = title;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.onClose();
                window.removeEventListener("message", this.onMessage);
                this.disposeOpenedFrame();
            }
        }
    ], [
        {
            key: "createAndShow",
            value: function createAndShow(position, params) {
                if (position.type === "inline") return new $1b1fc24fbadd3540$var$OpenedFrameInDiv(position.container, params);
                if (window.HTMLDialogElement) return new $1b1fc24fbadd3540$var$OpenedFrameUsingDialog(params);
                return new $1b1fc24fbadd3540$var$OpenedFrameUsingFallback(params);
            }
        }
    ]);
    return OpenedFrame;
}();
var $1b1fc24fbadd3540$var$OpenedFrameInDiv = /*#__PURE__*/ function(OpenedFrame) {
    "use strict";
    (0, $b973482bb46f63c0$export$71511d61b312f219)(OpenedFrameInDiv, OpenedFrame);
    var _super = (0, $7edbffc731202888$export$71511d61b312f219)(OpenedFrameInDiv);
    function OpenedFrameInDiv(parentDiv, params) {
        (0, $ae6d6fc22a088c75$export$71511d61b312f219)(this, OpenedFrameInDiv);
        var _this;
        _this = _super.call(this, params);
        _this.parentDiv = parentDiv;
        _this.parentDiv.appendChild(_this.iframeRef);
        return _this;
    }
    (0, $3704bfa0c5d9913b$export$71511d61b312f219)(OpenedFrameInDiv, [
        {
            key: "disposeOpenedFrame",
            value: function disposeOpenedFrame() {
                this.iframeRef.remove();
            }
        }
    ]);
    return OpenedFrameInDiv;
}($1b1fc24fbadd3540$export$3e24ee5c984ce043);
var $1b1fc24fbadd3540$var$FullscreenOpenedFrame = /*#__PURE__*/ function(OpenedFrame) {
    "use strict";
    (0, $b973482bb46f63c0$export$71511d61b312f219)(FullscreenOpenedFrame, OpenedFrame);
    var _super = (0, $7edbffc731202888$export$71511d61b312f219)(FullscreenOpenedFrame);
    function FullscreenOpenedFrame(params) {
        (0, $ae6d6fc22a088c75$export$71511d61b312f219)(this, FullscreenOpenedFrame);
        var _this;
        _this = _super.call(this, params);
        _this.onResize = function() {
            requestAnimationFrame(function() {
                _this.updateSizes();
            });
        };
        _this.updateSizes = function() {
            var fullScreen = window.innerWidth <= (0, $5c1d3452864e33ad$export$5b18f7c6fa2072f9) || !_this.isOrder;
            if (fullScreen) {
                _this.iframeRef.style.top = "0";
                _this.iframeRef.style.left = "0";
                _this.iframeRef.style.transform = "none";
                _this.iframeRef.style.width = "100%";
                _this.iframeRef.style.height = "100%";
                _this.iframeRef.style.borderRadius = "0px";
            } else {
                var height = (0, $5c1d3452864e33ad$export$e822326ea8388e5c)(window.innerHeight, false);
                _this.iframeRef.style.top = "50%";
                _this.iframeRef.style.left = "50%";
                _this.iframeRef.style.transform = "translate(-50%, -50%)";
                _this.iframeRef.style.width = "".concat((0, $5c1d3452864e33ad$export$136acee104ecd4c2)(height), "px");
                _this.iframeRef.style.height = "".concat(height, "px");
                _this.iframeRef.style.borderRadius = "16px";
            }
        };
        _this.isOrder = !!params.isOrder;
        _this.iframeRef.style.overflow = "hidden";
        _this.updateSizes();
        window.addEventListener("resize", _this.onResize);
        _this.backgroundColor = params.isOrder ? "rgba(0,0,0,0.3)" : "transparent";
        document.body.style.overflow = "hidden";
        if ((0, $c2e2b57d23484fd4$export$942a24f0838e8755)() === "Android") _this.iframeRef.style.minHeight = "".concat(window.innerHeight, "px");
        return _this;
    }
    (0, $3704bfa0c5d9913b$export$71511d61b312f219)(FullscreenOpenedFrame, [
        {
            key: "disposeOpenedFrame",
            value: function disposeOpenedFrame() {
                document.body.style.overflow = "unset";
                window.removeEventListener("resize", this.onResize);
                this.disposeFullscreen();
            }
        }
    ]);
    return FullscreenOpenedFrame;
}($1b1fc24fbadd3540$export$3e24ee5c984ce043);
var $1b1fc24fbadd3540$var$OpenedFrameUsingDialog = /*#__PURE__*/ function(FullscreenOpenedFrame) {
    "use strict";
    (0, $b973482bb46f63c0$export$71511d61b312f219)(OpenedFrameUsingDialog, FullscreenOpenedFrame);
    var _super = (0, $7edbffc731202888$export$71511d61b312f219)(OpenedFrameUsingDialog);
    function OpenedFrameUsingDialog(params) {
        (0, $ae6d6fc22a088c75$export$71511d61b312f219)(this, OpenedFrameUsingDialog);
        var _this;
        _this = _super.call(this, params);
        _this.dialogRef = document.createElement("dialog");
        _this.dialogRef.className = $1b1fc24fbadd3540$var$classForWidgetDialog;
        _this.dialogRef.ariaLabel = params.title;
        _this.dialogRef.ariaModal = "true";
        _this.dialogRef.style.all = "unset";
        var style = document.createElement("style");
        style.textContent = "\n      .".concat($1b1fc24fbadd3540$var$classForWidgetDialog, "::backdrop {\n        background-color: ").concat(_this.backgroundColor, "; !important;\n      }\n    ");
        _this.dialogRef.appendChild(style);
        _this.iframeRef.style.position = "fixed";
        _this.dialogRef.appendChild(_this.iframeRef);
        window.document.body.appendChild(_this.dialogRef);
        _this.dialogRef.showModal();
        return _this;
    }
    (0, $3704bfa0c5d9913b$export$71511d61b312f219)(OpenedFrameUsingDialog, [
        {
            key: "disposeFullscreen",
            value: function disposeFullscreen() {
                this.dialogRef.close();
                this.dialogRef.remove();
            }
        }
    ]);
    return OpenedFrameUsingDialog;
}($1b1fc24fbadd3540$var$FullscreenOpenedFrame);
var $1b1fc24fbadd3540$var$OpenedFrameUsingFallback = /*#__PURE__*/ function(FullscreenOpenedFrame) {
    "use strict";
    (0, $b973482bb46f63c0$export$71511d61b312f219)(OpenedFrameUsingFallback, FullscreenOpenedFrame);
    var _super = (0, $7edbffc731202888$export$71511d61b312f219)(OpenedFrameUsingFallback);
    function OpenedFrameUsingFallback(params) {
        (0, $ae6d6fc22a088c75$export$71511d61b312f219)(this, OpenedFrameUsingFallback);
        var _this;
        _this = _super.call(this, params);
        _this.divRef = document.createElement("div");
        _this.divRef.style.position = "fixed";
        _this.divRef.style.left = "0";
        _this.divRef.style.right = "0";
        _this.divRef.style.top = "0";
        _this.divRef.style.bottom = "0";
        _this.divRef.style.background = _this.backgroundColor;
        _this.divRef.style.zIndex = "2147483646";
        _this.focusTrapEls = [
            (0, $276aee0d389a2674$export$bbcd0e6c1e676d75)(_this.iframeRef),
            (0, $276aee0d389a2674$export$bbcd0e6c1e676d75)(_this.iframeRef)
        ];
        _this.iframeRef.style.position = "absolute";
        _this.divRef.appendChild(_this.focusTrapEls[0].htmlElement);
        _this.divRef.appendChild(_this.iframeRef);
        _this.divRef.appendChild(_this.focusTrapEls[1].htmlElement);
        document.body.appendChild(_this.divRef);
        _this.iframeRef.focus();
        setTimeout(function() {
            _this.iframeRef.focus();
        });
        return _this;
    }
    (0, $3704bfa0c5d9913b$export$71511d61b312f219)(OpenedFrameUsingFallback, [
        {
            key: "disposeFullscreen",
            value: function disposeFullscreen() {
                this.focusTrapEls.forEach(function(el) {
                    return el.dispose();
                });
                this.divRef.remove();
            }
        }
    ]);
    return OpenedFrameUsingFallback;
}($1b1fc24fbadd3540$var$FullscreenOpenedFrame);


var $d45fb9704d14a693$var$isBrowserSupported = function() {
    return $d45fb9704d14a693$var$cssPropertySupported("display", [
        "-ms-flexbox",
        "-webkit-box",
        "flex"
    ]) && !$d45fb9704d14a693$var$isIe();
};
var $d45fb9704d14a693$export$2e2bcd8739ae039 = $d45fb9704d14a693$var$isBrowserSupported;
// from https://stackoverflow.com/a/53191596/275473
var $d45fb9704d14a693$var$cssPropertySupported = function() {
    var mem = {}; // save test results for efficient future calls with same parameters
    return function cssPropertySupported(prop, values) {
        if (mem[prop + values]) return mem[prop + values];
        var element = document.createElement("p");
        var index = values.length;
        var name;
        var result = false;
        try {
            while(index--){
                name = values[index];
                element.style.display = name;
                if (element.style.display === name) {
                    result = true;
                    break;
                }
            }
        } catch (e) {
        // Empty
        }
        mem[prop + values] = result;
        return result;
    };
}();
function $d45fb9704d14a693$var$isIe() {
    // https://stackoverflow.com/a/19868056/275473
    return "ActiveXObject" in window;
}


var $9d825ff5713d6b33$export$136e89ab9856f57f = /*#__PURE__*/ function() {
    "use strict";
    function BridgeApi(config, singleBridgeGuard) {
        var _this = this;
        (0, $ae6d6fc22a088c75$export$71511d61b312f219)(this, BridgeApi);
        this.config = config;
        this.singleBridgeGuard = singleBridgeGuard;
        this.handleMessage = function(e) {
            var payload = e.data;
            if (!(payload === null || payload === void 0 ? void 0 : payload.type)) return;
            var _this_config = _this.config, bridgeToken = _this_config.bridgeToken, clientName = _this_config.clientName, product = _this_config.product, trackingInfo = _this_config.trackingInfo, onEvent = _this_config.onEvent, onLoad = _this_config.onLoad, onSuccess = _this_config.onSuccess;
            if (!_this.openedBridge) return;
            switch(payload.type){
                case (0, $363bde3f99059239$export$cb62ff1a452a903a).Close:
                    var closeData = payload.data;
                    _this.close(closeData);
                    break;
                case (0, $363bde3f99059239$export$cb62ff1a452a903a).Event:
                    var eventData = payload.data;
                    if (eventData) {
                        var payload1 = eventData.payload, type = eventData.type; // HACK, we don't show not public events here
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent(type, payload1);
                        if (type === "OPEN") $33345473c24fad8c$export$89db4734f6c919c4({
                            name: "widget_total_open_time",
                            type: "gauge",
                            value: Date.now() - _this.openedBridge.frame.openTimestamp
                        });
                    }
                    break;
                case (0, $363bde3f99059239$export$cb62ff1a452a903a).Onload:
                    _this.sendMessage({
                        source: "bridge",
                        data: {
                            bridgeToken: bridgeToken,
                            clientName: clientName,
                            product: product,
                            trackingInfo: trackingInfo,
                            origin: _this.openedBridge.windowParams.origin,
                            additionalInfo: _this.additionalInfo,
                            queryParams: _this.openedBridge.windowParams.queryParams
                        },
                        type: (0, $9976d56c67b51897$export$d0e2ae08fc9533f5).Init
                    });
                    onEvent === null || onEvent === void 0 ? void 0 : onEvent("LOAD", {
                        bridge_token: _this.config.bridgeToken
                    });
                    onLoad === null || onLoad === void 0 ? void 0 : onLoad();
                    break;
                case (0, $363bde3f99059239$export$cb62ff1a452a903a).Success:
                    var successData = payload.data;
                    if (!successData) throw new Error("data is missing in context");
                    var taskId = successData.taskId, publicToken = successData.publicToken, employer = successData.employer;
                    if (!publicToken) throw new Error("publicToken is missing in context.data");
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(publicToken, {
                        task_id: taskId,
                        employer: employer
                    });
                    _this.close(employer ? {
                        employer: employer
                    } : undefined);
                    break;
                case (0, $363bde3f99059239$export$cb62ff1a452a903a).Available:
                    break;
                case (0, $363bde3f99059239$export$cb62ff1a452a903a).TitleChange:
                    _this.openedBridge.frame.changeIframeTitle(payload.data.title);
                    break;
                case (0, $363bde3f99059239$export$cb62ff1a452a903a).OpenExternalLink:
                    var _this_config_internal_onExternalLinkProcessor, _this_config_internal;
                    (_this_config_internal = _this.config.internal) === null || _this_config_internal === void 0 ? void 0 : (_this_config_internal_onExternalLinkProcessor = _this_config_internal.onExternalLinkProcessor) === null || _this_config_internal_onExternalLinkProcessor === void 0 ? void 0 : _this_config_internal_onExternalLinkProcessor.call(_this_config_internal, payload.data.url);
                    break;
                default:
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    var _$e = payload;
            }
        };
        this.sendMessage = function(payload) {
            if (!_this.openedBridge) throw new Error("openedBridge object is not found");
            _this.openedBridge.frame.postMessage(payload);
        };
        this.additionalInfo = undefined;
        this.openedBridge = null;
        if (config.autoOpen) this.open();
        else if (!config.bridgeToken) // eslint-disable-next-line no-console
        console.error("bridgeToken is required");
    }
    (0, $3704bfa0c5d9913b$export$71511d61b312f219)(BridgeApi, [
        {
            key: "filterAndGroupQueryParams",
            value: function filterAndGroupQueryParams(queryParamsRaw) {
                var flags = {};
                var queryParams = {};
                Object.keys(queryParamsRaw).forEach(function(key) {
                    var value = queryParamsRaw[key];
                    if (key.startsWith("ab") || key.startsWith("ff")) {
                        if (value && typeof value === "string") flags[key] = value;
                    } else if (!key.startsWith("TRUV_TEST")) queryParams[key] = value;
                });
                return {
                    flags: flags,
                    queryParams: queryParams
                };
            }
        },
        {
            key: "initIframe",
            value: function initIframe() {
                var _this = this;
                var _this_additionalInfo;
                var releaseSingleBridgeGuard = this.singleBridgeGuard();
                if (this.openedBridge || releaseSingleBridgeGuard === null) return;
                var _ref = new URL(window.document.location.href), origin = _ref.origin, search = _ref.search;
                var _this_config_params;
                var _this_filterAndGroupQueryParams = this.filterAndGroupQueryParams((_this_config_params = this.config.params) !== null && _this_config_params !== void 0 ? _this_config_params : (0, $h0yJl.decodeQueryParams)(search)), flags = _this_filterAndGroupQueryParams.flags, queryParams = _this_filterAndGroupQueryParams.queryParams;
                var _this_config_position;
                var position = (_this_config_position = this.config.position) !== null && _this_config_position !== void 0 ? _this_config_position : {
                    type: (0, $13c7c3b2195a3dc2$export$693e1fbc8da770bb)
                };
                var params = new URLSearchParams();
                params.append("bridge_token", this.config.bridgeToken);
                params.append("is_mobile_app", ((_this_additionalInfo = this.additionalInfo) === null || _this_additionalInfo === void 0 ? void 0 : _this_additionalInfo.isMobileApp) ? "true" : "false");
                params.append("position", position.type);
                Object.keys(flags).forEach(function(key) {
                    return params.append("flag_" + key, flags[key]);
                });
                Object.keys(queryParams).forEach(function(key) {
                    var value = queryParams[key];
                    if (Array.isArray(value)) value.forEach(function(singleValue) {
                        return params.append("param_" + key, singleValue);
                    });
                    else params.append("param_" + key, value);
                });
                var newFlowUsed = false;
                var availableMessageReceived = false;
                var activeSrc;
                if (0, $2e9681744f3b402f$export$b0ef60cad22b508e) {
                    params.set("iframe-mode", "new");
                    newFlowUsed = true;
                    activeSrc = "".concat((0, $2e9681744f3b402f$export$b0ef60cad22b508e), "?").concat(params.toString());
                } else {
                    params.set("iframe-mode", "classic");
                    activeSrc = "".concat((0, $2e9681744f3b402f$export$dfceade7048162e2), "?").concat(params.toString());
                }
                this.openedBridge = {
                    frame: (0, $1b1fc24fbadd3540$export$3e24ee5c984ce043).createAndShow(position, {
                        iframeSrc: activeSrc,
                        title: "Truv",
                        id: "citadel-widget-flow",
                        onMessage: function(event) {
                            if (event.data.type === (0, $363bde3f99059239$export$cb62ff1a452a903a).Available) availableMessageReceived = true;
                            _this.handleMessage(event);
                        },
                        onClose: releaseSingleBridgeGuard
                    }),
                    windowParams: {
                        origin: origin,
                        queryParams: queryParams
                    }
                };
                var openedBridge = this.openedBridge;
                setTimeout(function() {
                    if (newFlowUsed && !availableMessageReceived) {
                        params.set("iframe-mode", "fallback");
                        openedBridge.frame.changeIframeSrc("".concat((0, $2e9681744f3b402f$export$dfceade7048162e2), "?").concat(params.toString()));
                    }
                }, 1500);
            }
        },
        {
            key: "open",
            value: function open() {
                var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this_config_internal;
                if (!(0, $d45fb9704d14a693$export$2e2bcd8739ae039)()) {
                    var _this_config_onEvent, _this_config, _this_config_onClose, _this_config1;
                    (_this_config_onEvent = (_this_config = this.config).onEvent) === null || _this_config_onEvent === void 0 ? void 0 : _this_config_onEvent.call(_this_config, "UNSUPPORTED_BROWSER", {
                        bridge_token: this.config.bridgeToken
                    });
                    (_this_config_onClose = (_this_config1 = this.config).onClose) === null || _this_config_onClose === void 0 ? void 0 : _this_config_onClose.call(_this_config1);
                    return;
                }
                if (!this.config.bridgeToken) {
                    var _this_config_onClose1, _this_config2;
                    // eslint-disable-next-line no-console
                    console.error("bridgeToken is required");
                    (_this_config_onClose1 = (_this_config2 = this.config).onClose) === null || _this_config_onClose1 === void 0 ? void 0 : _this_config_onClose1.call(_this_config2);
                    return;
                }
                var newAdditionalInfo = (0, $1110e77a396dfbda$export$71511d61b312f219)((0, $8805f4be77169222$export$71511d61b312f219)({}, this.config.additionalInfo, config.additionalInfo), {
                    originalReferrer: window.document.referrer
                });
                if ((_this_config_internal = this.config.internal) === null || _this_config_internal === void 0 ? void 0 : _this_config_internal.onExternalLinkProcessor) newAdditionalInfo.hasExternalLinkProcessor = true;
                this.additionalInfo = newAdditionalInfo;
                this.initIframe();
            }
        },
        {
            key: "close",
            value: function close(closeData) {
                var _this_config_onEvent, _this_config, _this_config_onClose, _this_config1;
                if (!this.openedBridge) return;
                this.openedBridge.frame.dispose();
                this.openedBridge = null;
                (_this_config_onEvent = (_this_config = this.config).onEvent) === null || _this_config_onEvent === void 0 ? void 0 : _this_config_onEvent.call(_this_config, "CLOSE", (0, $1110e77a396dfbda$export$71511d61b312f219)((0, $8805f4be77169222$export$71511d61b312f219)({}, closeData !== null && closeData !== void 0 ? closeData : {}), {
                    bridge_token: this.config.bridgeToken
                }));
                (_this_config_onClose = (_this_config1 = this.config).onClose) === null || _this_config_onClose === void 0 ? void 0 : _this_config_onClose.call(_this_config1);
            }
        },
        {
            key: "setBridgeTokenResponse",
            value: function setBridgeTokenResponse(data) {
                this.sendMessage({
                    source: "bridge",
                    type: (0, $9976d56c67b51897$export$d0e2ae08fc9533f5).SetBridgeTokenResponse,
                    data: data
                });
            }
        },
        {
            key: "setCategorizedCompaniesResponse",
            value: function setCategorizedCompaniesResponse(data) {
                this.sendMessage({
                    source: "bridge",
                    type: (0, $9976d56c67b51897$export$d0e2ae08fc9533f5).SetCategorizedCompaniesResponse,
                    data: data
                });
            }
        },
        {
            key: "setProvidersResponse",
            value: function setProvidersResponse(data) {
                this.sendMessage({
                    source: "bridge",
                    type: (0, $9976d56c67b51897$export$d0e2ae08fc9533f5).SetProvidersResponse,
                    data: data
                });
            }
        },
        {
            key: "back",
            value: function back() {
                this.sendMessage({
                    source: "bridge",
                    type: (0, $9976d56c67b51897$export$d0e2ae08fc9533f5).GoBack
                });
            }
        },
        {
            key: "onExternalLoginSuccess",
            value: function onExternalLoginSuccess(data) {
                this.sendMessage({
                    source: "bridge",
                    type: (0, $9976d56c67b51897$export$d0e2ae08fc9533f5).ExternalLoginSuccess,
                    data: data
                });
            }
        },
        {
            key: "onOAuthResult",
            value: function onOAuthResult(data) {
                this.sendMessage({
                    source: "bridge",
                    type: (0, $9976d56c67b51897$export$d0e2ae08fc9533f5).BridgeOAuthResult,
                    data: data
                });
            }
        }
    ]);
    return BridgeApi;
}();






var $0d4d42757f40c410$export$d7d9fb0b66163477 = /*#__PURE__*/ function() {
    "use strict";
    function OrderApi(config, singleBridgeGuard) {
        var _this = this;
        (0, $ae6d6fc22a088c75$export$71511d61b312f219)(this, OrderApi);
        this.config = config;
        this.singleBridgeGuard = singleBridgeGuard;
        this.handleMessage = function(event) {
            var _event_data;
            if (_this.openedFrame && ((_event_data = event.data) === null || _event_data === void 0 ? void 0 : _event_data.type) === (0, $de02b661938e3b6b$export$de3c5c76757a9816)) {
                var _this_config_onLoad, _this_config, _this_config_onSuccess, _this_config1, _this_config_onEvent, _this_config2;
                if (event.data.message.source === (0, $de02b661938e3b6b$export$6c64c0450660f009).Order && event.data.message.type === "CLOSE") {
                    var _this_config_onClose, _this_config3;
                    _this.close();
                    (_this_config_onClose = (_this_config3 = _this.config).onClose) === null || _this_config_onClose === void 0 ? void 0 : _this_config_onClose.call(_this_config3);
                }
                if (event.data.message.source === (0, $de02b661938e3b6b$export$6c64c0450660f009).Order && event.data.message.type === "LOAD") (_this_config_onLoad = (_this_config = _this.config).onLoad) === null || _this_config_onLoad === void 0 ? void 0 : _this_config_onLoad.call(_this_config);
                if (event.data.message.source === (0, $de02b661938e3b6b$export$6c64c0450660f009).Order && event.data.message.type === "SUCCESS") (_this_config_onSuccess = (_this_config1 = _this.config).onSuccess) === null || _this_config_onSuccess === void 0 ? void 0 : _this_config_onSuccess.call(_this_config1);
                (_this_config_onEvent = (_this_config2 = _this.config).onEvent) === null || _this_config_onEvent === void 0 ? void 0 : _this_config_onEvent.call(_this_config2, event.data.message.type, event.data.message.payload, event.data.message.source);
            }
        };
        this.openedFrame = null;
    }
    (0, $3704bfa0c5d9913b$export$71511d61b312f219)(OrderApi, [
        {
            key: "open",
            value: function open() {
                var releaseSingleBridgeGuard = this.singleBridgeGuard();
                if (this.openedFrame || releaseSingleBridgeGuard === null) return;
                var _this_config_position;
                var position = (_this_config_position = this.config.position) !== null && _this_config_position !== void 0 ? _this_config_position : {
                    type: "dialog"
                };
                var _httpsmytruvcomorders;
                var url = new URL((_httpsmytruvcomorders = "https://my.truv.com/orders/") !== null && _httpsmytruvcomorders !== void 0 ? _httpsmytruvcomorders : "");
                url.searchParams.append("bridge_token", this.config.bridgeToken);
                url.searchParams.append("environment", "iframe");
                this.openedFrame = (0, $1b1fc24fbadd3540$export$3e24ee5c984ce043).createAndShow(position, {
                    isOrder: true,
                    iframeSrc: url.toString(),
                    title: "Truv Order",
                    id: "truv-order-flow",
                    onMessage: this.handleMessage,
                    onClose: releaseSingleBridgeGuard
                });
            }
        },
        {
            key: "close",
            value: function close() {
                if (this.openedFrame) {
                    this.openedFrame.dispose();
                    this.openedFrame = null;
                }
            }
        }
    ]);
    return OrderApi;
}();


var $3d6e772b81c37542$var$bridgeIsOpened = false;
var $3d6e772b81c37542$var$singleBridgeGuard = function() {
    if ($3d6e772b81c37542$var$bridgeIsOpened) {
        // eslint-disable-next-line no-console
        console.error("The bridge is already open");
        return null;
    }
    $3d6e772b81c37542$var$bridgeIsOpened = true;
    return function() {
        $3d6e772b81c37542$var$bridgeIsOpened = false;
    };
};
var $3d6e772b81c37542$var$truvBridge = {
    init: function(config) {
        return config.isOrder ? new (0, $0d4d42757f40c410$export$d7d9fb0b66163477)(config, $3d6e772b81c37542$var$singleBridgeGuard) : new (0, $9d825ff5713d6b33$export$136e89ab9856f57f)(config, $3d6e772b81c37542$var$singleBridgeGuard);
    },
    findGetParameter: function(parameterName) {
        var params = (0, $h0yJl.decodeQueryParams)(window.location.search);
        return params[parameterName];
    }
};
var $3d6e772b81c37542$var$truvOrder = {
    init: function(config) {
        return new (0, $0d4d42757f40c410$export$d7d9fb0b66163477)(config, $3d6e772b81c37542$var$singleBridgeGuard);
    }
};
if (typeof window !== "undefined") {
    Object.defineProperty(window, "TruvBridge", {
        get: function() {
            return $3d6e772b81c37542$var$truvBridge;
        }
    });
    Object.defineProperty(window, "TruvOrder", {
        get: function() {
            return $3d6e772b81c37542$var$truvOrder;
        }
    });
    // it's just to keep compatibility to previous name
    Object.defineProperty(window, "CitadelBridge", {
        get: function() {
            return window.TruvBridge;
        }
    });
}

})();
//# sourceMappingURL=bridge.js.map
